import React, { type FC } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Pressable, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const baseStyles = xcss({
	height: '40px',
	width: '44px',
	borderRadius: 'radius.small',
	border: 'none',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
	position: 'relative' as any,
	backgroundSize: 'cover',
	backgroundPosition: 'center',
	backgroundRepeat: 'no-repeat',
});

const selectedStyles = xcss({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
	boxShadow: `inset 0 0 0 2px ${token('color.border.selected')}` as any,
});

const canBeSelectedStyles = xcss({
	cursor: 'auto',
});

type ExternalSiteImageThumbnailProps = {
	canBeSelected: boolean;
	children?: React.ReactNode;
	image: string;
	isSelected: boolean;
	onClick: () => void;
};

export const ExternalSiteImageThumbnail: FC<ExternalSiteImageThumbnailProps> = ({
	image,
	isSelected,
	canBeSelected,
	onClick,
	children,
}) => {
	return (
		<Pressable
			// rerender when isSelected is changed to fix the issue when the component was not updated
			key={`${image} ${isSelected ? '1' : '0'}`}
			aria-pressed={isSelected}
			xcss={[baseStyles, canBeSelected && canBeSelectedStyles, isSelected && selectedStyles]}
			style={{
				backgroundImage: `url(${image})`,
			}}
			onClick={onClick}
		>
			{children}
		</Pressable>
	);
};
